import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import flatpickr from 'flatpickr';
import { RatesService } from 'src/app/api/hospitality/rates.service';
import { RoomtypeService } from 'src/app/api/hospitality/roomtype.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;

@Component({
  selector: 'app-rates-prices',
  templateUrl: './rates-prices.component.html',
  styleUrls: ['./rates-prices.component.css']
})
export class RatesPricesComponent implements OnInit, AfterViewInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  roomtypes: any = [];
  roomtypes_detail: any = [];
  edit_roomtypes: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private ratesService: RatesService,
    private roomtypeService: RoomtypeService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      abbreviation: [null],
      start_date: [null],
      end_date: [null],
      is_show: [true]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
      this.ratesService.get(this.checkId).subscribe({
        next: (data: any) => {
          let item_ = data.data;
          this.roomtypes_detail = data.roomtypes_detail;
          this.item.patchValue({
            description: item_.description,
            abbreviation: item_.abbreviation,
            start_date: item_.start_date,
            end_date: item_.end_date,
            is_show: item_.is_show
          });
        }
      });
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    // this.getRoomTypes();
  }

  ngAfterViewInit(): void {
    flatpickr('#start_date', {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });

    flatpickr('#end_date', {
      altInput: true,
      altFormat: 'd-m-Y',
      dateFormat: 'Y-m-d',
      enableTime: false
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getRoomTypes() {
    this.roomtypeService.all().subscribe({
      next: (data: any) => {
        this.roomtypes = data.results.map((item: any) => {
          return {
            ...item, // los valores que vienen del backend
            rate_id: this.checkId, // extra
            roomtype_id: item.id, // extra
            price_public: null, // extra
            price_person_additional: null, // extra
            price_bed_additional: null, // extra
            price_corporate: null, // extra
            price_web: null, // extra
            is_active: true // extra
          };
        });
        this.roomtypes_detail = [...this.roomtypes];
      }
    });
  }

  changeIsActive(index: number, event: Event) {
    const input = event.target as HTMLInputElement;
    this.roomtypes_detail[index].is_active = input.checked;
    // console.log("Nuevo estado:", this.roomtypes_detail[index].is_active);
  }

  changePricePublic(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.roomtypes_detail[index].price_public = value_;
    }
  }
  changePriceCorporate(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.roomtypes_detail[index].price_corporate = value_;
    }
  }

  changePriceWeb(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.roomtypes_detail[index].price_web = value_;
    }
  }

  changePricePersonAdditional(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.roomtypes_detail[index].price_person_additional = value_;
    }
  }

  changePriceBedAdditional(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.roomtypes_detail[index].price_bed_additional = value_;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    data.item = this.item.value;
    data.roomtypes_detail = this.roomtypes_detail;
    if (this.validate()) {
      if (this.isEdit) {
        this.ratesService.updatePrices(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success(
              'Configuración de precios realizado con éxito'
            );
            // this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/hoteleria/tarifas/lista']);
  }
}
